import { render, staticRenderFns } from "./londonsuite.vue?vue&type=template&id=68f7a0e1&scoped=true&"
import script from "./londonsuite.vue?vue&type=script&lang=js&"
export * from "./londonsuite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f7a0e1",
  null
  
)

export default component.exports